import { render } from "./AutomaticChecks.vue?vue&type=template&id=ed489bbe&scoped=true"
import script from "./AutomaticChecks.vue?vue&type=script&lang=js"
export * from "./AutomaticChecks.vue?vue&type=script&lang=js"

import "./AutomaticChecks.vue?vue&type=style&index=0&id=ed489bbe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed489bbe"]])

export default __exports__